// extracted by mini-css-extract-plugin
export default {"alert":"SuccessSaveToastWithoutRedux_alert__WTuBF"};